// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"681":"754af22c","814":"a72b96a0"}[chunkId] + ".chunk.js";
};